import { CSSObject } from "styled-components";
import { vfxTheme } from "../common/VFX-UI/Theme/theme";

interface organizationStyles {
  organizationDetailsContainer: CSSObject;
  organizationContainer: CSSObject;
  tabItem: CSSObject;
  logoPreview: CSSObject;
}

const useOrganizationStyles = (): organizationStyles => {
  
  return {
    organizationDetailsContainer: {
      width: "100%",
    },
    organizationContainer: {
      width: "100%",
      boxShadow: vfxTheme.shadowTypes.container,
      padding: "1.5rem",
      borderRadius: "5px",
    },
    tabItem: {
      color: vfxTheme.palette.blueGreys.bg500,
      fontFamily: vfxTheme.fontFamily,
      fontEeight: vfxTheme.fontWeights.semiBold,
      fontSize: "1.25em",
      lineHeight: "1.5rem",
    },
    logoPreview: {
      maxWidth: "90%",
      height: "10em",
      objectFit: "contain",
    },
  };
};

export default useOrganizationStyles;
